import { Telemetry, ValidTelemetryEvent } from '~commonInfra/services/Telemetry';

export const dashboardQABetaTermsAcceptedEventType = 'site_dashboard_qa_beta_terms_accepted';
export const DASHBOARD_QA_BETA_TERMS_VERSION = '1.0';

export interface DashboardQABetaTermsAcceptedEvent extends ValidTelemetryEvent {
  type: string;
  terms_version: string;
}

export function sendDashboardQABetaTermsAcceptedTelemetry() {
  Telemetry.sendEvent<DashboardQABetaTermsAcceptedEvent>({
    type: dashboardQABetaTermsAcceptedEventType,
    terms_version: DASHBOARD_QA_BETA_TERMS_VERSION
  });
}
